/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Header from "../Shared/Header";
import CatalogWithoutImg from "../Shared/CatalogList/CatalogWitoutImg";
import Login from "./Login";
import SignUp from "./SignUp";
import styled from "styled-components";
import LoginPageNew from "./LoginPageNew";



export const SiteLoginNew = () => {

const LOginCont = styled.div`

background-color: #fff;
max-width: 100vw;
height: 100vh;
overflow: hidden;
padding: 3rem;
background-color:rgba(245, 255, 215, 0.92);


@media (max-width: 761px) {
padding: 0rem;
border-radius:0px;
`

const InnerCont = styled.div`

display: flex;
justify-content: flex-start;
align-items: center;


max-height: 100vh;
max-width: 100vw;
width: 100%;
height: 100%;
box-shadow: rgba(29, 29, 41, 0.1) 0px 0px 16px;
border-radius: 1.5rem;

padding-right: 4rem;
background-color: #fff;
img{
border:1px solid rgba(106, 106, 106, 0.37);
border-width:0px;
border-right-width: 1px;
}

@media (max-width: 761px) {
 img{
display:none;
 }
padding-right: 0rem;

 .imagecont{
  display:none;
  width:100%;
 }
  border-radius:0px;

}
`

  return (
  
      <LOginCont container direction={"column"} >
    {/*     <Header /> */}
     
       <InnerCont >

        <div className="imagecont" style={{width:'51%',width:'100%',objectFit:'contain',height:'100%',maxWidth:'51vw'}}>
          <img src="/temp_images/signup and login.png" alt="home top" style={{width:'100%',height:'100%',objectFit:'contain',padding:'0rem'}}/>
        </div>
    
          <LoginPageNew />
        
       </InnerCont>
      </LOginCont>
   
  );
};

export const SiteSignupNew = () => {





const LOginCont = styled.div`

background-color: #fff;
max-width: 100vw;
height: 100vh;
overflow: hidden;
padding: 3rem;
background-color:rgba(245, 255, 215, 0.92);


@media (max-width: 761px) {
padding: 0rem;
border-radius:0px;


}

  @media (max-width: 1351px) {


}

@media (max-width: 753px) {
width: 100%;

}

  @media (max-width: 761px) {
padding: 0rem 0rem 0rem 0rem;
}
`

const InnerCont = styled.div`

display: flex;
justify-content: flex-start;
align-items: center;


max-height: 100vh;
max-width: 100vw;
width: 100%;
height: 100%;
box-shadow: rgba(29, 29, 41, 0.1) 0px 0px 16px;
border-radius: 1.5rem;

padding-right: 4rem;
background-color: #fff;
img{
border:1px solid rgba(106, 106, 106, 0.37);
border-width:0px;
border-right-width: 1px;
}

@media (max-width: 761px) {
 img{
display:none;
 }
padding-right: 0rem;

 .imagecont{
  display:none;
  width:100%;
 }
  border-radius:0px;

}
`


  return (
    <React.Fragment>
    <LOginCont container direction={"column"} >
    {/*     <Header /> */}
     
       <InnerCont >

        <div className="imagecont" style={{width:'51%',width:'100%',objectFit:'contain',height:'100%',maxWidth:'51vw'}}>
          <img src="/temp_images/signup and login.png" alt="home top" style={{width:'100%',height:'100%',objectFit:'contain',padding:'0rem'}}/>
        </div>
    
          <SignUp/>
        
       </InnerCont>
      </LOginCont>
    </React.Fragment>
  );
};
// Styled Components
const StyledContainer = styled(Grid)`
    background-color: #fff;
    max-width: 100vw;
    height: 100vh;
`;

const StyledBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    box-shadow: rgba(29, 29, 41, 0.1) 0px 0px 16px;
    width: min-content;
    padding: 2rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: auto;
    margin-bottom: auto;
    border-radius: 11px;
`;

const StyledImage = styled.img`
    border-radius: 11px;
    width: 311px;
    height: 321px;
`;

const StyledSignupGrid = styled(Grid)`
    min-height: 100vh;
`;

// Updated Components
export const SiteLoginStyled = () => {
    return (
        <React.Fragment>
            <StyledContainer container direction={"column"}>
                <Header />
                <StyledBox>
                    <div>
                        <StyledImage src="/pexels-cottonbro-3585001.jpg" alt="home top" />
                    </div>
                    <Login />
                </StyledBox>
            </StyledContainer>
        </React.Fragment>
    );
};

export const SiteSignupStyled = () => {
    return (
        <React.Fragment>
            <Grid container direction={"column"}>
                <Header />
            {/*     <CatalogWithoutImg /> */}
                <StyledSignupGrid
                    container
                    spacing={2}
                    direction={"row"}
                    sx={{
                        alignSelf: "center",
                    }}
                >
                    <StyledBox>
                        <div>
                            <StyledImage src="/pexels-cottonbro-3585001.jpg" alt="home top" />
                        </div>
                      {/*   <SignUp /> */}
                    </StyledBox>
                </StyledSignupGrid>
            </Grid>
        </React.Fragment>
    );
};